// extracted by mini-css-extract-plugin
export var label = "_jw-2";
export var slideContainer = "_jw-0";
export var slider = "_jw-1";